<template>
  <component :is="component"
    v-bind="data"
    v-if="component"
    @updated="updated"
    @saved="saved"></component>
</template>
<script>
export default {
  name: 'v-dynamic-loader',
  props: {
    data: {
      type: [Object],
    },
    viewURL: {
      type: [String],
      required: true,
    },
  },
  data() {
    return {
      component: null,
    };
  },
  computed: {
    loader() {
      return () => import(`@/views/${this.viewURL}`);
    },
  },
  mounted() {
    this.loader()
      .then(() => {
        this.component = () => import(`@/views/${this.viewURL}`);
      })
      .catch(() => {
        // this.component = () => import('templates/default')
      });
  },
  methods: {
    updated(data) {
      this.$emit('updated', data);
    },
    saved(data) {
      this.$emit('saved', data);
    },
  },
};
</script>
